import React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import MuiButton from '@material-ui/core/Button'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import { Power4 } from 'gsap'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import WithStylesProps from '@/hoc/WithStylesProps'
import { getThemeColor } from '@/utils/themes'
import { fonts, layouts } from '@/utils/preset'
import { desktop, laptop, tabletL, tabletS, mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'

class CVButton extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      visible: true
    }
  }
  componentDidMount () {
    this.form = document.getElementById('form')
    const options = {
      root: null,
      rootMargin: '0px 0px',
      threshold: 0
    }
    this.observer = new window.IntersectionObserver(this.handleIntersection, options)
    this.observer.observe(this.form)
  }
  componentWillUnmount () {
    this.observer.disconnect()
  }
  handleClick = (event, path) => {
    if (path.indexOf('#') === -1) {
      return
    }
    event.preventDefault()
    const id = path.substring(path.indexOf('#') + 1)
    const target = document.getElementById(id)
    if (!target) {
      return
    }
    window.TweenMax.to(document.getElementById('root'), 0.6, {
      ease: Power4.easeInOut,
      scrollTo: {
        y: `#${id}`
      }
    })
  }
  handleIntersection = (entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        this.setState({
          visible: false
        })
      } else {
        this.setState({
          visible: true
        })
      }
    })
  }
  render () {
    const { theme, classes, children, className, color, ...other } = this.props
    return (
      <Root visible={this.state.visible}>
        <MuiButton
          className={className}
          variant="contained"
          component={Link}
          classes={classes}
          css={styles.Root}
          onClick={e => this.handleClick(e, this.props.to)}
          {...other}
        >
          {children}
          <ArrowDownwardIcon />
        </MuiButton>
      </Root>
    )
  }
}

const getStyles = (props) => {
  const color = props.color || 'primary'
  return {
    backgroundColor: getThemeColor(color, props.theme),
    color: getThemeColor(color, props.theme, 'contrast'),
    hoverBackgroundColor: getThemeColor(color, props.theme, 'hover')
  }
}

const muiStyles = props => {
  const styles = getStyles(props)
  const media = {
    mobile: `@media ${mq.and(mobile)}`
  }
  return {
    root: {
      backgroundColor: styles.backgroundColor,
      color: styles.color,
      height: rem(50),
      borderRadius: 0,
      borderTopLeftRadius: rem(10),
      borderTopRightRadius: rem(10),
      [media.mobile]: {
        height: rem(64),
        borderRadius: 0
      },
      padding: 0,
      fontSize: rem(16),
      fontFamily: fonts.base,
      boxShadow: 'none',
      justifyContent: 'center',
      alignItems: 'center',
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: styles.hoverBackgroundColor,
        boxShadow: 'none',
        '@media (hover: none)': {
          backgroundColor: styles.backgroundColor
        },
        '&:disabled': {
          backgroundColor: styles.backgroundColor
        }
      },
      '&:disabled': {
        backgroundColor: styles.backgroundColor,
        color: styles.color,
        opacity: 0.6
      },
      '& svg': {
        position: 'absolute',
        top: '50%',
        right: rem(16),
        transform: 'translateY(-50%)',
        fontSize: rem(16)
      }
    }
  }
}

const Root = styled.div`
  position: fixed;
  display: flex;
  z-index: 100;
  transition: transform 0.2s ease;
  transform: ${props => props.visible
    ? 'translateY(0%)'
    : 'translateY(100%)'
  };

  @media ${mq.and(desktop, laptop, tabletL)} {
    display: none;
  }
  @media ${mq.and(tabletS)} {
    bottom: 0;
    right: ${rem(layouts.defs.pad.tablet)};
    width: ${rem(240)};
  }
  @media ${mq.and(mobile)} {
    border-radius: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    padding: 0;
  }
`

const styles = {
  Root: css`
    width: 100%;
    justify-content: center;
    align-items: center;
  `
}

export default ThemeConsumer(WithStylesProps(muiStyles)(CVButton))
